// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mcKGqOx2dyDycFsMiYm9 {
  margin-top: 25px;
  height: 34px;
}
`, "",{"version":3,"sources":["webpack://./../../graylog2-server/graylog2-web-interface/src/components/event-definitions/event-definition-types/AggregationConditionExpression.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[":local(.formControlNoLabel) {\n  margin-top: 25px;\n  height: 34px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formControlNoLabel": `mcKGqOx2dyDycFsMiYm9`
};
export default ___CSS_LOADER_EXPORT___;
